exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-area[data-v-40a9a8f0]{font-size:1.3em!important;line-height:1.3em!important}", ""]);

// exports
